// extracted by mini-css-extract-plugin
export default {"Stats":"PostStats_Stats__K8UoT","Stats__Stat":"PostStats_Stats__Stat__6hdeI"};